import { getAxiosInstance } from './axiosInstance';
import { useGlobalErrorHandler } from './useGlobalErrorHandler';
import { useAppContext } from '@context/AppContext';

export const useDrugsService = () => {
    const handleUnauthorized = useGlobalErrorHandler();
    const appState = useAppContext().state;

    const getAllDrugs = async (): Promise<any> => {
        const axiosInstance = getAxiosInstance( appState , handleUnauthorized );
        const { data } = await axiosInstance.get(`/drugs`);
        return data;
    };

    const putDrug = async ( idItem: any , params: any ): Promise<any> => {
        const axiosInstance = getAxiosInstance( appState , handleUnauthorized );
        const { data } = await axiosInstance.put(`/drugs/${idItem}` , params );
        return data;
    };

    const postDrug = async ( params: any ): Promise<any> => {
        const axiosInstance = getAxiosInstance( appState , handleUnauthorized );
        const { data } = await axiosInstance.post(`/drugs` , params );
        return data;
    };

    const getDrugWithDetail = async ( idItem: any ): Promise<any> => {
        const axiosInstance = getAxiosInstance( appState , handleUnauthorized );
        const { data } = await axiosInstance.get(`/drugs/${idItem}`);
        return data;
    };

    const putDrugDetail = async ( idItem: any , params: any ): Promise<any> => {
        const axiosInstance = getAxiosInstance( appState , handleUnauthorized );
        const { data } = await axiosInstance.put(`/drugs/detail/${idItem}` , params );
        return data;
    };

    const postDrugDetail = async ( idItem: any , params: any ): Promise<any> => {
        const axiosInstance = getAxiosInstance( appState , handleUnauthorized );
        const { data } = await axiosInstance.post(`/drugs/${idItem}/detail` , params );
        return data;
    };

    return {
        getAllDrugs ,
        putDrug ,
        postDrug ,
        getDrugWithDetail ,
        putDrugDetail ,
        postDrugDetail
    };
}